import { Page } from "@roc/feature-app-core";
import { Route } from "react-router";
import { AutomationTechDashboard } from "../components/automationTechDashboard";

export const getAutomationTechDashboardInternalRoutesConfig = (
  basePath: string,
  baseUrl: string
) => {
  return {
    automationTechDashboard: {
      path: `${basePath}/automation-tech-dashboard`,
      url: `${baseUrl}/automation-tech-dashboard`,
      documentTitle: 'automation-tech-dashboard',
    }
  }
};

export const getAutomationTechDashboardInternalRoutes = (
  basePath: string,
  baseUrl: string,
) => {
  const config = getAutomationTechDashboardInternalRoutesConfig(basePath, baseUrl);

  return {
    automationTechDashboard: (
      <Route exact path={config.automationTechDashboard.path}>
        <Page routeDefinition={config.automationTechDashboard}>
          <AutomationTechDashboard/>
        </Page>
      </Route>
    )
  }
}
